import { styled } from '@mui/material/styles';
import React from 'react';
import PropTypes from 'prop-types';

import Reveal from './Reveal';

const StyledLead = styled('div')(({ theme }) => ({
  background: (theme.vars || theme).palette.background.transparent,
  color: (theme.vars || theme).palette.text.primary,
  textShadow: '1px 1px 1px rgba(0, 0, 0, 0.3)',
  backdropFilter: 'blur(5px)',
  maxWidth: '90vw',
  borderRadius: '2vw',
  padding: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    maxWidth: '64vw',
    padding: theme.spacing(2),
  },
  [theme.breakpoints.up('lg')]: {
    maxWidth: '36vw',
    padding: theme.spacing(4),
  },
}));

const PageLead = ({ children = null, ...props }) => {
  return (
    <Reveal>
      <StyledLead {...props}>
        {children}
      </StyledLead>
    </Reveal>
  );
};

PageLead.propTypes = {
  children: PropTypes.node,
};

export default PageLead;